var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgXIcon2 = function SvgXIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.887 5.113c.476.476.566 1.157-.86 2.583L13.722 12l4.305 4.304c1.426 1.427 1.336 2.107.86 2.583-.475.475-1.156.565-2.582-.861L12 13.722l-4.304 4.304c-1.427 1.426-2.107 1.336-2.583.86-.475-.475-.565-1.155.86-2.582L10.28 12 5.975 7.696c-1.426-1.426-1.336-2.107-.86-2.583.475-.475 1.155-.565 2.582.861L12 10.278l4.304-4.304c1.426-1.426 2.107-1.336 2.582-.86z",
    fill: "#fff"
  })));
};
export default SvgXIcon2;